import i18n from '../localization';

/**
 * Get translated display name for a trait ID
 * @param traitId - The trait identifier (e.g., 'age', 'email', 'first_name')
 * @returns Translated display name or formatted fallback
 */
export const getTraitDisplayName = (traitId: string): string => {
  const translationKey = `traits:${traitId}`;
  const translation = i18n.t(translationKey, { defaultValue: traitId });
  
  // If translation is the same as traitId, it means no translation was found
  if (translation === traitId) {
    // Format the trait ID as fallback (snake_case -> Title Case)
    return traitId
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }
  
  return translation;
};